import { render, staticRenderFns } from "./PersAdd.vue?vue&type=template&id=e0f16438&scoped=true"
import script from "./PersAdd.vue?vue&type=script&lang=js"
export * from "./PersAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f16438",
  null
  
)

export default component.exports